module.exports = __webpack_public_path__ + "static/media/share-all.a47b6a17.svg";